import { css } from 'react-strict-dom';

export const color = css.defineVars({
  accent: '#c13031',
  accentBg: '#f7e5e5',
  neutral100: '#1f2433',
  neutral80: '#434a60',
  neutral60: '#646e87',
  neutral40: '#9fa6b6',
  neutral20: '#d9dce4',
  neutral10: '#eff0f3',
  neutral15: '#E7E9EE',
  neutral5: '#f7f8fb',
  neutral0: '#ffffff',
  link: '#0366d6',
  textDark: '#1c1d20',
  green: '#256029',
  greenBg: '#dcebdd',
  greenLight: '#2f9e44',
  greenLightBg: '#e7f5ea',
  blue: '#2f6db8',
  blueBg: '#ecf2f9',
  yellow: '#dd8503',
  yellowBg: '#fdf6eb',
  blueGrey: '#37474f',
  blueGreyBg: '#cfd8dc',
});
